<template>
  <div data-qa="stepper-div-hi8akb">
    <v-flex class="text-left ma-2" data-qa="stepper-flex-27p5el">
      <v-btn text :color="primaryColor"
              class="text-capitalize py-2 px-4"
              @click="goBack" data-qa="stepper-btn-cy233t9">
        <v-icon left class="material-symbols-outlined" size="18px" data-qa="stepper-icon-l6nevj">arrow_back</v-icon>
        {{ $t("common.goBack") }}
      </v-btn>
    </v-flex>
    <v-flex class="mx-2" data-qa="stepper-flex-3bzsxj">
    <v-card class="mx-auto" data-qa="stepper-card-hj8aun">
      <v-stepper v-model="options.config.step" data-qa="stepper-stepper-1hrhwu">
      <v-stepper-header v-if="options.component === 'BreakDeposit'" class="hidden-md-and-down" data-qa="stepper-stepper-header-0rjxwb">
        <template v-for="(step, index) in options.config.steps">
          <v-stepper-step
            :key="`step${index}`"
            :step="index+1"
            :color="primaryColor"
            :data-qa="`stepper-stepper-step-wm39v-${index}`">
            {{ `${$t(`termDepositActions.steps.${step.name}`)}` }}
          </v-stepper-step>
          <v-divider
            v-if="index !== options.config.steps.length-1"
            :key="`divider${index}`"
            :data-qa="`stepper-divider-s0qk1a-${index}`"></v-divider>
        </template>
      </v-stepper-header>
      <template v-if="options.component === 'BreakDeposit'" class="hidden-lg-and-up">
        <RadialStepper
          :config="{ steps: options.config.steps, state: options.config.step }"
          class="hidden-lg-and-up radial-stepper--background"
        />
      </template>

      <component :is="options.component" :config="options.config" />
        <v-card-actions class="ml-4 my-2 mt-10" data-qa="stepper-card-actions-op8gsh">
          <v-btn
            v-if="options.config.enableBackBtn"
            @click="previousStep(options.config)"
            :disabled="options.config.step === 1 || disableBackBtn"
            outlined
            :color="primaryColor"
            class="text-capitalize py-2 px-4"
           data-qa="stepper-btn-wwquoi">
            {{ $t("common.back") }}
          </v-btn>
          <v-btn
            @click="onConfirm(options.config)"
            :disabled="options.config.disableNextBtn"
            :color="primaryColor"
            class="text-capitalize white--text py-2 px-4"
           data-qa="stepper-btn-jn4zu6">
            {{ buttonLabel }}
          </v-btn>
        </v-card-actions>
      </v-stepper>
    </v-card>
    </v-flex>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'
import '@/styles/components/stepper.scss'
import event from '@/util/event'
import Snackbar from '@/components/DOB-ErrorHandler/Snackbar.vue'
import components from '@/views/accounts/termDepositActions/stepperHelper.js'

export default {
  name: 'Stepper',
  props: {
    options: Object
  },
  components: {
    ...components,
    Snackbar,
    RadialProgressBar,
    RadialStepper: () => import('@/components/RadialStepper.vue')
  },
  data () {
    return {
      buttonLabel: this.$t('common.next'),
      isLeavingRoute: false,
      disableBackBtn: false
    }
  },
  methods: {
    getNextButtonLabel (props) {
      if (!props.enableOTP) {
        this.buttonLabel =
        props.step === props.steps.length - 1
          ? this.$t('common.confirmLabel')
          : this.$t('common.next')
        return this.buttonLabel
      }
    },
    previousStep (props) {
      this.buttonLabel = this.$t('common.next')
      if (this.options.config.step <= this.options.config.steps.length) {
        this.options.config.step--
        props.stepName = props.steps[props.step - 1].name
      }
      event.$emit('onFormConfirm', props)
    },
    onModelChange (props) {
      for (const key in props) {
        this[key] = props[key]
      }
    },
    onConfirm (props) {
      if (props.step === props.steps.length - 1) {
        this.getNextButtonLabel(props)
      }
      if (props.step === props.steps.length) {
        if (this.buttonLabel === this.$t('common.confirmLabel')) {
          props.disableNextBtn = false
          if (props.enableOTP) {
            event.$emit('finalStepWithOTP', true)
          } else {
            event.$emit('finalStep', true)
          }
        } else {
          if (props.enableOTP) {
            setTimeout(() => {
              event.$emit('SEND_OTP', true)
            }, 100)
            event.$emit('verifyOTP', props)
          } else {
            event.$emit('IS_OTP_VALID', true)
          }
        }
      }
      if (props.step <= props.steps.length - 1) {
        props.stepName = props.steps[props.step].name
        props.step++
        event.$emit('onFormConfirm', props)
      }
    },
    goBack () {
      this.$emit('isGoingBack')
      if (this.options.routeFrom !== undefined) {
        this.$router.push('/deposits')
      } else this.$router.push('/home')
    }
  },
  created () {
    event.$on('disableNextBtn', args => {
      this.options.config.disableNextBtn = args
    })
    event.$on('IS_OTP_VALID', (valid) => {
      if (valid) {
        this.disableBackBtn = true
        this.options.config.disableNextBtn = true
      } else {
        this.buttonLabel = this.$t('common.next')
      }
    })
  },
  beforeDestroy () {
    event.$off('disableNextBtn', {})
    event.$off('IS_OTP_VALID', {})
  }
}
</script>
